import $ from 'jquery';
import dom from './dom';

const OPEN = 'nav-open';
const ANIMATEIN = 'animate-in';
const ANIMATEOUT = 'animate-out';
const TIMEOUT = 350;
const header = () => {
  const navToggle = $('.c-main-nav__toggle');
  const navWrapper = $('.c-main-nav__wrapper');

  const toggleNav = () => {
    if (dom.$body.hasClass(OPEN)) {
      dom.$body.removeClass(ANIMATEIN);
      dom.$body.addClass(ANIMATEOUT);
      dom.$doc.trigger('closeNav');
      setTimeout(() => {
        dom.$body.removeClass(`${OPEN} ${ANIMATEOUT}`);
      }, TIMEOUT);
    } else {
      dom.$body.addClass(`${OPEN} ${ANIMATEIN}`);
    }
  };
  if (navToggle && navToggle.length && navWrapper && navWrapper.length) {
    navToggle.click(() => {
      toggleNav();
    });
  }
  const closeNav = $('.c-main-nav__wrapper--backdrop, .c-main-nav__close');
  if (closeNav && closeNav.length) {
    closeNav.click(() => {
      toggleNav();
    });
  }
};
export default header;



// WEBPACK FOOTER //
// ./src/scripts/modules/header.js